// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBurLyQ2Uqe6Zz3z22pQn0cNIR2u5EGccs",
    authDomain: "zifaf-app.firebaseapp.com",
    projectId: "zifaf-app",
    storageBucket: "zifaf-app.appspot.com",
    messagingSenderId: "885328371741",
    appId: "1:885328371741:web:206ca89bc337d3f833e6f4",
    measurementId: "G-N8EZKMQ4JY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
export default getFirestore();